import React from "react";
import Checkbox from "@mui/material/Checkbox";

const CustomCheckbox = (props) => {
  const { ...attribute } = props;
  return <Checkbox size="small" {...attribute} />;
};

export default CustomCheckbox;
